import React, { useState } from "react";
import { NavLink } from "react-router-dom";

import "./Navigation.css";

import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";

import logo from "../../../assets/logo.png";
// import logoScroll from "../../../assets/logo-scroll.png";
import logoScroll from "../../../assets/rsto/Le_Logo1.png";

const Navigation = () => {
  const [scrolls, setScrolls] = useState(false);

  const [nav, setNav] = useState("nav_link nav_link-li");

  const handlerToActive = () => {
    setNav("nav-active nav_link");
  }
  const handlerClose = () => {
    setNav("nav_link nav_link-li");
  }

  const scrollOnChange = () => {
    if (window.scrollY < 80) {
      setScrolls(true);
    } else {
      setScrolls(false);
    }
  };

  window.addEventListener("scroll", scrollOnChange);

  // console.log(scrolls);
  return (
    <>
      <Navbar

        className={scrolls ? "navigation-bar navigation-bar-back d-none d-md-block" : "navigation-bar-back1 navigation-bar d-none d-md-block"}
        collapseOnSelect
        expand="md"

      >
        <Container>
          <NavLink
            className="d-md-none mx-auto navbar-brand navbar-nav"
            to="/"
            style={{ cursor: "pointer" }}
          >
            RES TAU RENT
          </NavLink>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav" className="d-flex justify-content-between align-items-center">
            <Nav className="">
              <NavLink to="/" className="nav-link">
                Home
              </NavLink>
              <NavLink to="/menu" className="nav-link">
                Menu
              </NavLink>
              <NavLink to="/reservation" className="nav-link">
                Catering
              </NavLink>

            </Nav>


            <Nav className="">
              {/* <NavLink to="/" className="nav-link">
                Gallery
              </NavLink> */}
              <NavLink to="/about" className="nav-link">
                About
              </NavLink>
              <NavLink to="/contact" className="nav-link">
                Contact
              </NavLink>
              <NavLink to="/reservation" className="nav-link animated-button victoria ms-2 my-0 nav-button">
                Reservation
              </NavLink>
            </Nav>
          </Navbar.Collapse>
          <Nav>

            <NavLink
              className="d-none d-md-block m-0 fw-bold text-uppercase navbar-brand navbar-nav  scroll-img"
              to="/"
              style={{ cursor: "pointer" }}
            >


              <img className={scrolls ? "scroll-img-img" : 'scroll-img-img-2'} src={logoScroll} alt="logo" />
              <br />
              <img className={scrolls ? "showMe" : 'showMe1'} src={logo} alt="logo" />


            </NavLink>
          </Nav>
        </Container>
      </Navbar>

      {/* mobile view */}

      <nav className="d-md-none">
        <NavLink className="logo nav-link" to="/">
          <img className="showMeMobile" src={logo} width="200px" alt="logo" />
        </NavLink>
        <div className="burger-items">
          <ul className={nav}>
            <li>
              <NavLink to="/" className="nav-link">Home</NavLink>
            </li>
            <li>
              <NavLink to="/menu" className="nav-link">Menu</NavLink>
            </li>
            <li>
              <NavLink to="/reservation" className="nav-link">Catering</NavLink>
            </li>
            <li>
              <NavLink to="/reservation" className="nav-link">Reservation</NavLink>
            </li>
            {/* <li>
            <NavLink to="/gallery">Gallery</NavLink>
          </li> */}
            <li>
              <NavLink to="/about" className="nav-link">About</NavLink>
            </li>
            <li>
              <NavLink to="/contact" className="nav-link">Contact</NavLink>
            </li >
          </ul >
        </div>
        {
          nav === "nav_link nav_link-li" &&
          <div onClick={handlerToActive} className="burger">
            <div className="line1"></div>
            <div className="line2"></div>
            <div className="line3"></div>
          </div>
        }
        {
          nav === "nav-active nav_link" &&
          <div onClick={handlerClose} className="burger toggle">
            <div className="line1"></div>
            <div className="line2"></div>
            <div className="line3"></div>
          </div>
        }
      </nav >
    </>
  );
};

export default Navigation;
